var map = {
	"./img1.jpg": "a6ad",
	"./img2.jpg": "b29c",
	"./img3.jpg": "fdb2",
	"./img4.jpg": "c730",
	"./img5.jpg": "1617",
	"./img6.jpg": "cf32",
	"./img7.jpg": "46b4",
	"./img8.png": "beca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1743";